import React, { useContext, useEffect, useState } from "react";
import { Table, Button, Layout, message, Breadcrumb } from "antd";
import { PendingAction } from "../../../core/interfaces/PendingAction";
import { fetchPendingActionsData } from "../../../core/services/account-request.service";
import { UserContext } from "../../../context/user-context";
import { statusDescriptions } from "../../../utilities/constants";
import { format } from "date-fns";

import { CalClient } from "@cvx/cal";
import { environment } from "../../../environments/environment";
import { appInsights } from "../../../core/services/insight.service";

import { Link, useNavigate } from "react-router-dom";
import GlobalErrorMessage from "../../global-error/GlobalErrorMessage";

const { Content } = Layout;

const PendingMyAction: React.FC = () => {
  const [pendingActions, setPendingActions] = useState<PendingAction[]>([]);
  const [userEmail, setUserEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [graphUser, setGraphUser] = useState<any>({});
  const cal = new CalClient(environment.calConfig);
  const user = useContext(UserContext);
  const [apiError, setApiError] = useState(null);
  const navigate = useNavigate();
  const getStatusDescription = (status: number): string => {
    return statusDescriptions[status] || "Unknown Status";
  };
  const hardcodeemail = "JXXA@chevron.com";

  const handleRequestIdClick = (
    requestID: string,
    status: number,
    type: string
  ) => {
    const contextValue = {
      requestNumber: requestID,
      reqType: type == "ACCOUNT" ? "1" : "2",
      status: status.toString(),
      userEmail: user.email,
      frompending: true,
    };
    navigate(`/manage requests/request-detail?requestNumber=${contextValue.requestNumber}&reqType=${contextValue.reqType}&frompending=${contextValue.frompending}&userEmail=${contextValue.userEmail}`);
  };

  // Define table columns
  const columns = [
    {
      title: "Request",
      dataIndex: "requestID",
      key: "requestID",

      render: (
        requestID: string,
        record: { status: number; requestType: string }
      ) => (
        <Button
          type="link"
          onClick={() =>
            handleRequestIdClick(requestID, record.status, record.requestType)
          }
          style={{
            padding: 0,
            color: "blue",
            textDecoration: "underline",
          }}
        >
          {requestID}
        </Button>
      ),
    },
    {
      title: "Request Date",
      dataIndex: "requestDate",
      key: "requestDate",
      render: (date: string) => format(new Date(date), "d MMM yyyy"),
    },
    {
      title: "Request Type",
      dataIndex: "requestType",
      key: "requestType",
    },
    {
      title: "Entered By",
      dataIndex: "requesterName",
      key: "requesterName",
    },
  ];

  // Fetch data from the backend
  const fetchPendingMyActions = async (email: string) => {
    setLoading(true);
    try {
      const response = await fetchPendingActionsData(email); // Replace with the actual API function
      const filteredData = response
        .filter((action: PendingAction) => {
          return action.status < 90;
        })
        .map((action: PendingAction) => ({
          ...action,
          statusDescription: getStatusDescription(action.status), // Add status description
        }));
      setPendingActions(filteredData);
    } catch (error) {
      setApiError(error);
      message.error("Failed to fetch pending actions");
      appInsights.trackEvent({
        name: "GetPendingActionsFailed",
        properties: { error: error },
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await getUserEmail();
    };
    fetchData();
  }, []);

  useEffect(() => {
    // Use the hardcoded email to fetch data
    fetchPendingMyActions(user.email ?? "");
  }, []);

  const getUserEmail = async () => {
    try {
      const response = await cal.getUserPropertiesFromMsGraph([
        "userPrincipalName",
      ]);
      setGraphUser((prev: any) => ({ ...prev, ...user }));
      setGraphUser((prev: any) => ({
        ...prev,
        Emaild: response.userPrincipalName,
      }));
      setUserEmail(response.userPrincipalName);
      
    } catch (error) {
      setApiError(error);
      console.error("Error fetching user email:", error);
      appInsights.trackEvent({
        name: "GetUserEmailFailed",
        properties: { error: error },
      });
    }
  };

  const groupByStatus = (data: PendingAction[]) => {
    const groupedData = data.reduce(
      (groups: Record<number, PendingAction[]>, action) => {
        const status = action.status;
        if (!groups[status]) {
          groups[status] = [];
        }
        groups[status].push(action);
        return groups;
      },
      {}
    );
    
    return groupedData;
  };
  const handleRetry = () => {
    setApiError(null);
  };
  return (
    <>
      {apiError ? (
        <GlobalErrorMessage
          error={apiError}
          visible={!!apiError}
          onClose={() => setApiError(null)}
          onRetry={handleRetry}
        />
      ) : (
        <>
          <Breadcrumb
            items={[
              {
                title: "manage requests",
              },
              {
                title: "my pending actions",
              },
            ]}
          />
          <div className="div-container">
            {pendingActions.length === 0 && !loading ? (
              <div style={{ textAlign: "center", padding: "30px" }}>
                 <Table
                      dataSource={pendingActions}
                      columns={columns}
                      rowKey="RequestID"
                      loading={loading}
                      bordered={true}
                      size="small"
                      pagination={false}
                      className="white-cell-table"
                    />
              </div>
            ) : (
              Object.entries(groupByStatus(pendingActions)).map(
                ([status, actions]) => (
                  <div key={status} style={{ marginBottom: "30px" }}>
                    <h3>Status: {getStatusDescription(Number(status))}</h3>
                    <Table
                      dataSource={actions}
                      columns={columns}
                      rowKey="RequestID"
                      loading={loading}
                      bordered={true}
                      size="small"
                      pagination={false}
                      className="white-cell-table"
                    />
                  </div>
                )
              )
            )}
          </div>
          <Button
            type="default"
            style={{ marginLeft: "10px" }}
            onClick={() => window.history.back()}
          >
            Back
          </Button>
        </>
      )}
    </>
  );
};

export default PendingMyAction;
